<template>
  <Fragment>
    <template v-if="$route.name !== 'opinion'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>反馈人员姓名：</span>
              <el-input v-model="realName"></el-input>
            </div>
            <el-button type="primary" class="ml-20">查询</el-button>
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="区域名称" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="反馈人员" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="工号" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.staffCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.linkPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="反馈内容"
          show-overflow-tooltip
          class="el-tooltip__popper"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.feedBackInfo }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="20"
        :current-page="currentPage"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      realName: "",
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    };
  },
  mounted() {},
  methods: {
    //获取售后反馈列表
    getOpinionInfo() {
      let _this = this;
      let param = {
        url: "/api/salePerson/getOpinionInfo",
        params: {
          realName: _this.realName,
          pageNum: _this.currentPage,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getOpinionInfo", param).then(() => {
        _this.list = _this.$store.state.salePerson.opinionInfo.list;
        _this.total = _this.$store.state.salePerson.opinionInfo.total;
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
    },
    handlePrePage() {
      this.currentPage -= 1;
    },
    handleNextPage() {
      this.currentPage += 1;
    }
  },
  created() {
    //获取售后反馈列表
    let _this = this;
    _this.getOpinionInfo();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
    .card-content
        display: flex
        align-items: center
        justify-content: space-between

        .left
            display: flex

        .el-button
            font-size: 14px

        .search-name, .search-code
            font-size: 14px
            display: flex
            align-items: center

            span
                white-space: nowrap

    .pagination
        text-align: center
</style>
<style lang="css">
/**
    组件中使用 scoped style 是无法命中它的。可以加一个非 scoped 的 style 标签，如果不想对项目的所有 Tooltip 都生效，可以使用 popper-class 属性。
     */
.el-tooltip__popper {
  max-width: 50%;
}
</style>
